import * as React from "react";
import { cn } from "../../lib/utils";
import { LucideIcon } from "lucide-react";

interface SegmentOption {
  key: string;
  label: string;
  icon?: LucideIcon;
}

interface SegmentProps {
  options: string[] | SegmentOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  classActive?: string;
  classInactive?: string;
}

export const Segment: React.FC<SegmentProps> = ({ 
  options, 
  value, 
  onChange, 
  className, 
  classActive = "bg-white text-blue-600 shadow", 
  classInactive = "text-gray-600 hover:bg-gray-200"
}) => {
  const isStringArray = typeof options[0] === 'string';
  
  return (
    <div className={cn("inline-flex rounded-lg bg-gray-100 p-1", className)}>
      {options.map((option) => {
        const key = isStringArray ? option as string : (option as SegmentOption).key;
        const label = isStringArray ? option as string : (option as SegmentOption).label;
        const Icon = !isStringArray ? (option as SegmentOption).icon : undefined;
        
        return (
          <button
            key={label}
            type="button"
            className={cn(
              "px-4 py-1 text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2 min-w-[160px]",
              value === key
                ? classActive
                : classInactive
            )}
            onClick={() => onChange(key)}
          >
            {Icon && <Icon size={16} />}
            {label}
          </button>
        );
      })}
    </div>
  );
};